/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/7/30
 * Time: 14:44
 * Desc: 基础设置-云店设置—开票说明配置
 */

import { Component, Vue } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import { IPSService } from '@/services/ipsServices';
import editorOptionConfig from '@/library/utils/editerOptionConfig'; // 富文本编辑器全局配置
import { appEnvConfig } from '@/configs/appConfigs';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import baseAPIService from '@/services/base/baseAPIService';
import { Functions } from '@/library/utils/functions';
// 子组件
import { EmpServiceAPIActions } from '@/services/empService';
import { EmpResConfig } from '@/services/empService/config';
@Component({
  components: {
    quillEditor,
    NoAuth,
  },
})
export default class Receipt extends Vue {
  /* 数据 */

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * 富文本配置
   * @type {ItemObject}
   */
  public editorOptionConfig: ItemObject = editorOptionConfig();

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 全屏loading
   * @type {boolean}
   */
  public fullscreenLoading = false;

  /**
   * 上传的图标地址
   * @type {string}
   */
  public uploadPic = '';

  /**
   * 当前添加图片的富文本
   * @type {null}
   */
  public addRang: any = {};

  /**
   * 开票说明内容
   * @type {string}
   */
  public receiptContent = '';

  /**
   * 会员权益说明
   * @type {string}
   */
  public memberBenefitsNote = '';

  // 会员等级相关配置
  public memberLevelData: Array<{ levelName?: string; levelCode?: string; levelPic?: string }> = [];

  /* 方法 */

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    this.fullscreenLoading = true;
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 500;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 500Kb!');
    }
    if (!((isJpg || isPng || isGif) && LtSize)) { this.fullscreenLoading = false; }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  public uploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.fullscreenLoading = false;
    this.uploadPic = res.content;
    this.addRang.insertEmbed(this.addRang.getSelection().index, 'image', res.content); // 调用编辑器的 insertEmbed 方法，插入URL
    // 调整光标位置
    this.addRang.getSelection(this.addRang.getSelection().index + 1);
  }

  /**
   * 图片上传失败
   * @return null
   */

  public uploadImgError() {
    this.$message.error('图片上传失败');
    this.fullscreenLoading = false;
  }

  /**
   * 点击图片ICON触发事件
   */
  public imgHandler() {
    // @ts-expect-error
    this.addRang = this.$refs.receipt.quill;
    // @ts-expect-error
    document.querySelector('#imgInput').click();
  }

  /**
   * 会员等级相关配置
   * @return null
   */
  public getMemberLevel(): void {
    const me = this;
    IPSService.adminMemberLevelConfig({}).then((res: any) => {
      me.memberLevelData = res ? res.memberConfig : {};
    });
  }

  /**
   * 获取集团的开票说明
   * @return null
   */
  public getRecieptInfo(): void {
    IPSService.invoiceNote({}).then((res) => {
      this.receiptContent = res.invoiceNote || '';
      this.memberBenefitsNote = res.memberBenefitsNote || '';
    });
  }

  /**
   * 更新集团开票说明
   * @return null
   */
  public onSaveeRecieptInfo(): void {
    const invoiceNote = this.receiptContent ? this.receiptContent : '';
    const memberBenefitsNote = this.memberBenefitsNote ? this.memberBenefitsNote : '';
    const postParams = {
      invoiceNote,
      memberBenefitsNote,
    };
    IPSService.invoiceNoteSave({ postParams }).then((res) => {
      if (res) {
        this.$message.success('保存成功');
      } else {
        this.$message.success('保存失败');
      }
    });

    this.levelConfigSave();
  }

  /**
   * 更新会员等级
   */
  public levelConfigSave() {
    IPSService.adminMemberLevelConfigSave({ postParams: { memberConfig: this.memberLevelData } }).then((res) => {
      if (res) {
        this.$message.success('会员等级更新成功');
      } else {
        this.$message.success('会员等级更新失败');
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getRecieptInfo(); // 获取集团的开票说明
    this.getMemberLevel();
  }

  /**
   * 当组建创建完成
   */
  public mounted() {
    // 为图片Icon绑定事件
    // @ts-expect-error
    this.$refs.receipt.quill.getModule('toolbar').addHandler('image', this.imgHandler);
  }

  /**
   * 图片上传成功时的处理
   * @return null
   */
  public uploadImageSuccessNormal(res: any, file: any, index?: number): void {
    // this.distributeStrategyForm.secondSharePicture = res.content;

    this.memberLevelData.splice(index, 1, Object.assign({}, this.memberLevelData[index], { levelPic: res.content }));
  }

  /**
   * 图片上传失败
   * @return null
   */
  public uploadImgErrorNormal(): void {
    this.$message.error('图片上传失败');
  }

  /**
   * 图片上传之前(普通)
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUploadNormal(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 300;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 300Kb!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 删除已上传的图片
   * @return null
   */
  public onDeletePic(): void {}

  /**
   * 图片放大
   * @return null
   */
  public onMagnifyPic(): void {}

  /**
   * 新增会员等级
   */
  public addLevel() {
    this.memberLevelData.splice(this.memberLevelData.length, 1, { levelName: '', levelCode: '', levelPic: '' });
  }

  /**
   * 删除会员等级
   */
  public delLevel(index) {
    this.$confirm('确认删除该选项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      this.memberLevelData.splice(index, 1);
    });
  }
}
